var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardDaysLeftTrial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 0.5C18.0129 0.5 17.2188 1.29414 17.2188 2.28125V8.21875C17.2188 9.20586 18.0129 10 19 10C19.9871 10 20.7812 9.20586 20.7812 8.21875V4.16641C28.4703 5.04961 34.4375 11.5734 34.4375 19.5C34.4375 28.0277 27.5277 34.9375 19 34.9375C10.4723 34.9375 3.5625 28.0277 3.5625 19.5C3.5625 16.2863 4.54219 13.3027 6.21953 10.8313C6.77617 10.0148 6.56094 8.90898 5.74453 8.35977C4.92812 7.81055 3.82227 8.01836 3.27305 8.83477C1.20977 11.8703 0 15.5441 0 19.5C0 29.9945 8.50547 38.5 19 38.5C29.4945 38.5 38 29.9945 38 19.5C38 9.00547 29.4945 0.5 19 0.5ZM14.3242 12.3008C13.6266 11.6031 12.4984 11.6031 11.8082 12.3008C11.118 12.9984 11.1105 14.1266 11.8082 14.8168L17.7457 20.7543C18.4434 21.452 19.5715 21.452 20.2617 20.7543C20.952 20.0566 20.9594 18.9285 20.2617 18.2383L14.3242 12.3008Z",
    fill: "#6B930D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardDaysLeftTrial);
export default __webpack_public_path__ + "static/media/dashboard-days-left-trial.e1573180b1109ea9cded1439ddea7cb8.svg";
export { ForwardRef as ReactComponent };